import background2 from "@/assets/images/landing_page/carousel_background/img-background-2.jpg";
import background3 from "@/assets/images/landing_page/carousel_background/img-background-3.jpg";
import background4 from "@/assets/images/landing_page/carousel_background/img-background-4.jpg";
import background4croped from "@/assets/images/landing_page/carousel_background/img-background-4-croped.jpg";

export const carouselBackgrounds = [
  {
    id: 1,
    title: "PLATFORM AGREGATOR SYARIAH PERTAMA",
    sub_title: "SELAMAT DATANG DI EFUNDING",
    description:
      "<p class='header-description' style='color: #FFFFFF'> Yang mendapat tanda <span style='color: #F7BD3A; font-weight: bold;'>Terdaftar</span> dari <b>Otoritas Jasa Keuangan</b><br> berdiri sejak tahun <b>2017.</b></p>",
    image_url: background3,
    image_croped: background3,
  },
  {
    id: 2,
    title: "AMAN, TRANSPARAN & TERPERCAYA",
    sub_title: "LEGALITAS TERJAMIN",
    description:
      "<p class='header-description' style='color: #FFFFFF'> Efunding telah mendapatkan tanda <span style='color: #F7BD3A; font-weight: bold;'>Terdaftar</span> dari<br> <b>Otoritas Jasa Keuangan</b> berdasarkan <b>Surat Nomor S-61/IK.01/2025.</b> </p>",
    image_url: background2,
    image_croped: background2,
  },
  {
    id: 3,
    title: "KAPAN SAJA <br>DIMANA SAJA",
    sub_title: "BUKA DEPOSITO ONLINE",
    description:
      "<p class='header-description' style='color: #FFFFFF'> Ga Perlu Antre di Bank, Mudah Tanpa Ribet <br>Tinggal Klik langsung dari HP/Gadget Kamu.</p>",
    image_url: background4,
    image_croped: background4croped,
    button: {
      label: "Buka Deposito Sekarang!",
      pathName: "/list-produk-deposito",
    },
  },
];



// WEBPACK FOOTER //
// ./src/utils/carousel_backgrounds.js